<template>
  <div>
    <div @click.prevent="doChangeStatus">
      <i :class="icon"></i>{{label}}
    </div>
    <div :class="[{ open: dialogStatus }, 'modal', 'confirmation-modal']">
      <div class="shadow" @click="closeDialogModal"></div>
      <div class="body">
        <i class="fal fa-times exit" @click="closeDialog"></i>
          <div >
            <div class="heading">Unable to Activate</div>
            <div class="info">Additional details are required before this may be activated.  Please ensure that a valid payment processor has been selected.</div>
            <div class="actions" style="float: none;">
              <div class="left leftButton">
                <button class="secondary" @click="closeDialog">Cancel</button>
              </div>
              <div class="right">
                <button class="primary" @click="this.$emit('emitEditEvent');" style="width: 12rem;">Finish Setting Up</button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex";
  import { eventBus } from "../main.js";

  export default {
    props: ["content", "rallyId", "newStatus"],
    data: () => {
      return {
        dialogStatus: false,
        iconLabelMap: {
          "0": { icon: "fal fa-edit", label: "Move To Draft" },
          "1": { icon: "fal fa-paper-plane", label: "Make Active" },
          "2": { icon: "fal fa-archive", label: "Archive" },
        },
      };
    },
    computed: {
      icon() {
        return this.iconLabelMap[this.newStatus].icon;
      },
      label() {
        return this.iconLabelMap[this.newStatus].label;
      },
    },
    methods: {
      ...mapActions("contents", ["updateContent"]),
      async doChangeStatus() {
        if (this.newStatus == "1" && this.content.attributes["needs-setup"]) {
          this.dialogStatus = true;
        } else {
          this.content.attributes["status"] = this.newStatus;
          this.updateContent({ content: this.content, rallyId: this.rallyId });
        }
      },
      closeDialog() {
        this.dialogStatus = false;
      },
      openDeleteModal() {
        this.dialogStatus = true;
      }
    }
  }
</script>
